// @ts-nocheck
import { getReplacementsList } from "@store/Framework/Services/PartFinderService";
import { PartModel } from "@store/Framework/Types/ApiModels";
import { ApiHandler, createHandlerChainRunner, HasOnSuccess } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandler<{ id?: string; partNumber?: string } & HasOnSuccess<PartModel[]>, PartModel[]>;

export const DispatchBeginLoadReplacementsData: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/PartFinder/BeginLoadReplacementsData",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    if (props.apiParameter.id) {
        props.apiResult = await getReplacementsList(props.apiParameter.id, props.apiParameter.partNumber || undefined);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const DispatchCompleteLoadReplacementsData: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/PartFinder/CompleteLoadReplacementsData",
        result: props.apiResult,
    });
};

export const chain = [
    DispatchBeginLoadReplacementsData,
    PopulateApiParameter,
    RequestDataFromApi,
    ExecuteOnSuccessCallback,
    DispatchCompleteLoadReplacementsData,
];

const loadReplacementsData = createHandlerChainRunner(chain, "LoadReplacementsData");
export default loadReplacementsData;
